import { isNative } from './platform';

/**
 * Haptic feedback utility. All methods are fire-and-forget no-ops on web.
 * Uses @capacitor/haptics — dynamically imported to avoid bundling on web.
 */
export const haptics = {
	/** Subtle tick — for button taps on primary actions */
	light() {
		if (!isNative()) return;
		import('@capacitor/haptics').then(({ Haptics, ImpactStyle }) => {
			Haptics.impact({ style: ImpactStyle.Light });
		}).catch(() => {});
	},

	/** Noticeable thud — for add to cart/proposal, successful login */
	medium() {
		if (!isNative()) return;
		import('@capacitor/haptics').then(({ Haptics, ImpactStyle }) => {
			Haptics.impact({ style: ImpactStyle.Medium });
		}).catch(() => {});
	},

	/** Double-tap pattern — for QR scan match, order submitted */
	success() {
		if (!isNative()) return;
		import('@capacitor/haptics').then(({ Haptics, NotificationType }) => {
			Haptics.notification({ type: NotificationType.Success });
		}).catch(() => {});
	},

	/** Error buzz — for invalid login, validation failure */
	error() {
		if (!isNative()) return;
		import('@capacitor/haptics').then(({ Haptics, NotificationType }) => {
			Haptics.notification({ type: NotificationType.Error });
		}).catch(() => {});
	},
};
